/** Clé de cache pour le stockage des informations de base du canal de distribution */
export const NEXT_BASE_CHANNEL_INFO_WINDOW_KEY = "__NEXT_BASE_CHANNEL_INFO__";

/** Clé de cache pour le stockage de la configuration du canal de distribution */
export const NEXT_CHANNEL_CONFIGURATION_WINDOW_KEY =
  "__NEXT_CHANNEL_CONFIGURATION__";

/** Clé de cache pour les messages de traductions de formatjs */
export const NEXT_INTL_MESSAGES_WINDOW_KEY = "__NEXT_INTL_MESSAGES__";
